import { render, staticRenderFns } from "./sidebar-bottom.vue?vue&type=template&id=267e7bec&"
import script from "./sidebar-bottom.vue?vue&type=script&lang=js&"
export * from "./sidebar-bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267e7bec')) {
      api.createRecord('267e7bec', component.options)
    } else {
      api.reload('267e7bec', component.options)
    }
    module.hot.accept("./sidebar-bottom.vue?vue&type=template&id=267e7bec&", function () {
      api.rerender('267e7bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/sidebar-bottom.vue"
export default component.exports